import { combineReducers } from 'redux';
import visit from './reducer/visit-reducer';
import GET from './reducer/GET-reducer';

export default combineReducers({
    visit,
    GET,
});